import { render } from "./LatestUpdates.vue?vue&type=template&id=b91eed76&ts=true"
import script from "./LatestUpdates.vue?vue&type=script&lang=ts"
export * from "./LatestUpdates.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__